import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import "./changeinvestmentmodal.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";

const ChangeInvestmentModal = (props) => {
  const [investmentStrategy, setInvestmentStrategy] = useState(
    props.investmentStrategyKey,
  );

  const handleCheck = (value) => {
    setInvestmentStrategy(value);
  };

  return (
    <div className="changeInvestmentPage">
      <Row>
        <Col>
          <div className="ch-small-close">
            <Link to="" aria-label="close investments modal">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="ch-title">Change investments</div>

          {props?.memberships?.memberships[0].status === "locked" ? (
            <div className="ch-sub-title">
              <span className="locked-pad">
                <Icons iconname="locked" variant="icon-sixteen-px" />
              </span>
              <span className="locked-text-pad">
                Changes to investments are currently pending. No further updates
                can be made at this time.
              </span>
            </div>
          ) : (
            <div className="ch-sub-title">
              Please select the investment type you would like to edit.
            </div>
          )}
        </Col>
      </Row>
      <Row className="second-row">
        <>
          <Col
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className="parent-change-investment mb-3 me-3"
          >
            <Col
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={4}
              className={
                props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                (props?.memberships?.memberships[0].status === "locked" &&
                  props?.memberships?.memberships[0]?.strategyName ===
                    "currentInvestmentsOnly")
                  ? "change-investment change-investment-greyed-bg"
                  : investmentStrategy === "currentInvestmentsAndFuturePayments"
                    ? "change-investment change-investment-bg"
                    : "change-investment"
              }
            >
              <div className="most-popular">
                <div className="most-popular-text">MOST POPULAR</div>
              </div>
              {!(
                props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                (props?.memberships?.memberships[0].status === "locked" &&
                  props?.memberships?.memberships[0]?.strategyName ===
                    "currentInvestmentsOnly")
              ) ? (
                <CustomCheckbox
                  name="changeInvestment"
                  defaultChecked={
                    investmentStrategy === "currentInvestmentsAndFuturePayments"
                      ? true
                      : false
                  }
                  variantName="custom-checkbox text-end"
                  onChange={() =>
                    handleCheck("currentInvestmentsAndFuturePayments")
                  }
                />
              ) : (
                <div className="manage-custom-checkbox custom-checkbox-align text-end">
                  <Icons iconname="locked" variant="icon-sixteen-px" />
                </div>
              )}
              <div className="current-future-icon">
                <Icons iconname="current-future" variant="icon-fourty-px" />
              </div>
              <p className="ch-head-text">The straightforward approach</p>
              <p className="ch-sub-text">
                Current investments and future payments
              </p>
            </Col>
            <Col className="text-change-investment">
              <div className="small-ch-text">
                We&apos;ll rebalance your pot and direct any future
                contributions in the proportion that you select.
              </div>
            </Col>{" "}
          </Col>
        </>
        <>
          <Col
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className="parent-change-investment mb-3 me-3"
          >
            <Col
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={4}
              className={
                props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                (props?.memberships?.memberships[0]?.status === "locked" &&
                  props?.memberships?.memberships[0]?.strategyName ===
                    "currentInvestmentsOnly")
                  ? "change-investment change-investment-greyed-bg"
                  : investmentStrategy === "currentInvestmentsOnly"
                    ? "change-investment change-investment-bg"
                    : "change-investment"
              }
            >
              {!(
                props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                (props?.memberships?.memberships[0]?.status === "locked" &&
                  props?.memberships?.memberships[0]?.strategyName ===
                    "currentInvestmentsOnly")
              ) ? (
                <CustomCheckbox
                  name="changeInvestment"
                  defaultChecked={
                    investmentStrategy === "currentInvestmentsOnly"
                      ? true
                      : false
                  }
                  variantName="custom-checkbox text-end"
                  onChange={() => handleCheck("currentInvestmentsOnly")}
                />
              ) : (
                <div className="manage-custom-checkbox custom-checkbox-align text-end">
                  <Icons iconname="locked" variant="icon-sixteen-px" />
                </div>
              )}
              <div className="current-icon">
                <Icons iconname="current" variant="icon-fourty-px" />
              </div>
              <p className="ch-head-text">
                Not ready to redirect future contributions?
              </p>
              <p className="ch-sub-text">Current investments only</p>
            </Col>
            <Col className="text-change-investment">
              <div className="small-ch-text">
                It&apos;s possible to update only your pot value and leave
                ongoing contributions as they are now. You&apos;ll need to
                manage separately your contributions from past investments going
                forward, until you update them both in the future.
              </div>
            </Col>{" "}
          </Col>
        </>
        <>
          <Col
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className="parent-change-investment mb-3 me-3"
          >
            <Col
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={4}
              className={
                props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                investmentStrategy === "futurePaymentsOnly"
                  ? "change-investment change-investment-bg"
                  : "change-investment"
              }
            >
              <CustomCheckbox
                name="changeInvestment"
                defaultChecked={
                  props?.memberships?.memberships[0]?.totalPotValue === 0 ||
                  investmentStrategy === "futurePaymentsOnly"
                    ? true
                    : false
                }
                variantName="custom-checkbox text-end"
                onChange={() => handleCheck("futurePaymentsOnly")}
              />

              <div className="future-icon">
                <Icons iconname="future" variant="icon-fourty-px" />
              </div>
              <p className="ch-head-text">
                Not ready to change past investments?
              </p>
              <p className="ch-sub-text">Future payments only</p>
            </Col>
            <Col className="text-change-investment">
              <div className="small-ch-text">
                It&apos;s possible to update only your future payments and leave
                past investments as they are now if you prefer. You&apos;ll need
                to manage separately your future payments from past investments
                going forward, until you update them both in the future.
              </div>
            </Col>{" "}
          </Col>
        </>
      </Row>
      <Row className="mt-3">
        <div className="ch-container-button">
          <div>
            <Buttons
              className="secondary"
              name="Back"
              handleClick={props.handleBack}
            />
          </div>
          <div className="ch-continue-button">
            <Buttons
              className="primary"
              name="Continue"
              handleClick={() => props.handleContinue(investmentStrategy)}
              disabled={false}
            />
          </div>
        </div>
      </Row>
    </div>
  );
};

export default ChangeInvestmentModal;
